import { useLocation } from '@shared/core/router.helper/reactRouter';
import { withWindow } from '@shared/utils/withWindow';
import type { Location } from 'history';
import { useEffect, useRef } from 'react';

type FreezeState = Maybe<{
  freeze: boolean;
}>;

// use freeze navigation's location for the <Switch /> you want to conditionally freeze navigation in
//
// The retained location is derived during render instead of mirrored into state. Mirroring cost a
// second render of the entire app on *every* URL change — including the ones Aloha's scroll spy
// writes while the guest scrolls — and made the first of those two renders show the location the
// guest had already left.
export const useFreezeNavigation = () => {
  const location = useLocation<FreezeState>();
  const lastUnfrozenLocation = useRef<Location<FreezeState>>(location);

  if (!location.state?.freeze) {
    lastUnfrozenLocation.current = location;
  }

  useEffect(() => {
    if (location.state?.freeze) {
      withWindow(window => window.history.replaceState(null, ''));
    }
  }, [location]);

  return {
    location: lastUnfrozenLocation.current,
  };
};
